<script setup>
import { JRelatedGroup } from "media-flow-ui"

import { ref, computed } from "vue"
import { storeToRefs } from "pinia"
import { usePageBuilder } from "~/stores/page-builder"

import { formatButtonStyle } from "~/helpers/button/button"
import { formatIconStyle } from "~/helpers/icon/icon"
import { formatComponentStyle } from "@/models/layout/style/component"

const pageBuilderStore = usePageBuilder()

const props = defineProps({
  data: {
    type: Object,
    required: false,
    default: false,
  },
  isList: {
    type: Boolean,
    default: false,
  },
  index: {
    type: Number,
    default: 1,
  },
})

const { getLayoutMediaData } = storeToRefs(pageBuilderStore)

const { data, isList, index } = props

const relatedParents = computed(() => {
  return getLayoutMediaData.value?.parents &&
    getLayoutMediaData.value?.parents[data.props.groupId]
    ? getLayoutMediaData.value.parents[data.props.groupId]
    : null
})
const relatedGroupData = computed(() => {
  return relatedParents.value ? relatedParents.value[index - 1] : null
})

const style = computed(() => formatComponentStyle(data?.style || {}))
const titleStyle = computed(() =>
  formatComponentStyle(data?.components?.title?.style || {})
)
const descriptionStyle = computed(() =>
  formatComponentStyle(data?.components?.description?.style || {})
)
const imageStyle = computed(() => {
  let formatedStyle = formatComponentStyle(data?.components?.image?.style || {})
  return {
    ...formatedStyle,
    minWidth: formatedStyle.width || "",
  }
})

const imgSource = computed(() => {
  if (
    relatedGroupData.value?.cardImages &&
    Object.keys(relatedGroupData.value?.cardImages).length
  ) {
    return (
      relatedGroupData.value?.cardImages["ar1_1"] ||
      relatedGroupData.value?.cardImages[
        Object.keys(relatedGroupData.value?.cardImages)[0]
      ]
    )
  }

  return null
})

const engagements = computed(() => {
  if (data && Object.keys(data.props.engagements).length) {
    return Object.values(data.props.engagements).map((e) => ({
      ...e.button,
      icon: formatIconStyle(e.button.icon),
      style: formatButtonStyle(e.button.style),
    }))
  }

  return []
})

const isRedirect = computed(
  () => data.components?.title?.props?.allowRedirect || false
)
const isImageRedirect = computed(
  () => data.components?.image?.props?.allowRedirect || false
)

const showTitle = computed(
  () => data.props.components?.includes("title") || false
)
const showDescription = computed(
  () => data.props.components?.includes("description") || false
)
const showImage = computed(
  () => data.props.components?.includes("image") || false
)
</script>

<template>
  <div class="related-group" :id="data.id">
    <JRelatedGroup
      v-if="relatedGroupData"
      :title="relatedGroupData.title || ''"
      :description="relatedGroupData.description || ''"
      :show-description="showDescription"
      :show-title="showTitle"
      :show-image="showImage"
      :title-style="titleStyle"
      :description-style="descriptionStyle"
      :image-src="imgSource"
      :engagements="engagements"
      :url="relatedGroupData.url"
      :is-redirect="isRedirect"
      :is-image-redirect="isImageRedirect"
      :is-image-rounded="
        data.components.image?.style
          ? data.components.image?.style?.type === 'rounded'
          : true
      "
      :image-style="imageStyle"
      :style="style"
    />
  </div>
</template>

<style></style>
